<template>
    <div v-click-outside="close" class="dropdown" :class="{ 'is-disabled': disabled }">
        <div ref="label" class="dropdown__label" @click="toggle" @contextmenu.prevent="toggle">
            <slot name="label" />
        </div>
        <transition name="fade">
            <ul v-show="visible" ref="dropdown" class="dropdown__list">
                <slot name="items" :close="close" />
            </ul>
        </transition>
    </div>
</template>

<script>
import Popper from 'popper.js';
import { clickOutside } from '@speechki-frontend/shared/helpers/directives/clickOutside';

export default {
    name: 'Dropdown',
    directives: {
        clickOutside
    },
    props: {
        popperOptions: {
            type: Object,
            default: () => {}
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            visible: false,
            mounted: false,
            popper: undefined
        };
    },
    beforeUnmount() {
        if (this.popper) {
            this.popper.destroy();
        }
    },
    methods: {
        toggle() {
            this.visible = !this.visible;
            let event = this.visible ? 'opened' : 'closed';
            if (event === 'opened') {
                this.$nextTick(() => {
                    this.setupPopper();
                });
            }
            this.$emit(event);
        },
        close() {
            if (!this.visible) return;
            this.visible = false;
            this.$emit('closed');
        },
        setupPopper() {
            if (this.popper === undefined) {
                this.popper = new Popper(this.$refs.label, this.$refs.dropdown, {
                    placement: 'bottom',
                    ...this.popperOptions
                });
            } else {
                this.popper.scheduleUpdate();
            }
        }
    }
};
</script>

<style lang="scss" src="./Dropdown.scss"></style>
